export default __webpack_public_path__ + "src/assets/twitter.9a005da8e854bccf89c2970744b3ed7a.svg";